<template>
  <!--弹框4 开始-->
  <el-dialog :visible.sync="frameRiseDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center style="text-align: center;">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/rise.png" class="frame-small-img" @click="refresh"></div>
      <div class="frame-text-rise" style="width: 90%;margin: 0 auto;">
        <div class="wordBreak">{{$t('justMissO')}} {{$t('offerSoldOut')}}</div>
        <div class="wordBreak">{{$t('updatePlan')}} <span style="font-weight: 500;color: #E12D2D;">{{common.currencySet()}} {{risePrice}}</span> {{$t('higherPriceOfSameRoom')}} {{$t('propertyIsRecommended')}} {{$t('wouldBookingIt')}}</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-goback" @click="goback">{{$t('back')}}</el-button>
      <el-button type="primary" class="dialog-goon" @click="writeOrderFun">{{$t('continueBooking')}}</el-button>
    </span>
    <publicMask :fullscreenLoading="fullscreenLoading"></publicMask>
  </el-dialog>
  <!--弹框4 结束-->
  <!--引入方式-->
  <!-- <frameRise :frameRiseDialog="frameRiseDialog" :risePrice="risePrice"></frameRise> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
import { updateVerifyPrice } from '@/request/order.js'
import publicMask from '@/components/public/publicMask'
export default {
  name: 'frameRise',
  props: ['frameRiseDialog', 'risePrice', 'curPageData'],
  components: {
    publicMask
  },
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      pageRefresh: 0,
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: '',
      source: 'roompai',
      fullscreenLoading: false,
      conver: ''
    }
  },
  created () {
    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }

    if (window.performance.navigation.type === 1) {
      // console.log('页面被刷新')
      this.pageRefresh = 1
    }
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
  },
  methods: {
    refresh () {
      location.reload()
      this.frameRiseDialog = false
    },
    reserve () {
      this.frameRiseDialog = false
    },
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.common.linkQuerys
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.common.linkQuerys.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid || ''
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
      })
    },
    goback: function () {
      var paysubmitInfo = {'click': 1}
      this.$emit('frameRiseBookingBackFun', paysubmitInfo)
    },
    writeOrderFun: function () {
      this.fullscreenLoading = true
      let locationHref = window.document.location.href
      var that = this

      var paysubmitInfo = {}
      // 客人同意涨价信息，修改验价价格
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var productJson = sessionStorage.getItem('productStr')
      var product = JSON.parse(productJson)
      product.totalprice = parseInt(product.totalprice) + parseInt(this.risePrice)
      sessionStorage.setItem('productStr', JSON.stringify(product))

      var currency = this.common.currencySet(this)
      // 如果是酒店详情页 点下单
      var query = this.common.linkQuerys
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.common.linkQuerys.hotelid
        this.adult = parseInt(this.common.linkQuerys.adult)
        this.child = parseInt(this.common.linkQuerys.child)
        this.room = isNaN(parseInt(this.common.linkQuerys.room)) ? 1 : parseInt(this.common.linkQuerys.room)
        this.startdate = this.common.linkQuerys.start_date
        this.enddate = this.common.linkQuerys.end_date
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid || ''
        this.adult = parseInt(params.adult)
        this.child = parseInt(params.child)
        this.room = parseInt(params.room)
        this.startdate = params.checkin
        this.enddate = params.checkout
      }

      var Sparams = this.$route.params
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(Sparams) === '{}' && searchData !== '{}') {
        Sparams = JSON.parse(searchData)
      }
      var sessionid = this.common.sessionidGet(this)

      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }
      // var childNums = []
      // if (Sparams !== null && JSON.stringify(Sparams.childNums) !== '{}') {
      //   childNums = Sparams.childNums
      // }
      var seleteds = ''
      var childNums = this.common.linkQuerys.childNums
      if (this.child !== undefined && this.child !== null && this.child !== '' && this.child > 0 && !isNaN(this.child)) {
        seleteds = childNums
      }

      var productStr = sessionStorage.getItem('productStr')

      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {
        'hotelid': this.hotelid,
        'product': productStr,
        'token': token,
        'room': this.room,
        'adult': this.adult,
        'child': this.child,
        'childNums': seleteds,
        'checkin': this.startdate,
        'checkout': this.enddate,
        'currency': currency,
        'source': this.source,
        'sessionid': sessionid,
        'roompaiToken': roompaiToken,
        'operation': 'updateVerifyPrice',
        'time': time
      }
      var data = this.common.encryptionData(dataJson, this)
      updateVerifyPrice(data).then(res => {
        this.fullscreenLoading = false

        if (res.flag === '001') {
          // 未登录
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.conver === 1 || this.conver === '1') {
            that.$router.push({name: 'login', query: {'source': this.source, 'conver': this.conver}})
          } else {
            that.$router.push({name: 'login', query: {'source': this.source}})
          }
        } if (res.flag === '156') {
          // 关闭弹矿 重试
          paysubmitInfo = {'click': 1}
          this.$emit('frameRiseBookingBackFun', paysubmitInfo)
        } else if (res.flag === '200') {
          if (that.curPageData === 'HotelDetail') {
            var orderDataR = {
              'hotelid': that.hotelid,
              'product': productStr,
              'checkin': that.startdate,
              'checkout': that.enddate,
              'room': that.room,
              'adult': that.adult,
              'child': that.child,
              'source': this.source,
              'childNums': seleteds
            }
            localStorage.setItem('orderData', JSON.stringify(orderDataR))
            if (this.conver === 1 || this.conver === '1') {
              that.$router.push({name: 'WriteOrder', params: orderDataR, query: {'source': this.source, 'conver': this.conver}})
            } else {
              that.$router.push({name: 'WriteOrder', params: orderDataR, query: {'source': this.source}})
            }
          } else if (that.curPageData === 'WriteOrder') {
            var submitInfo = {'click': 1}
            that.$emit('frameRiseBookingFun', submitInfo)
          } else if (that.curPageData === 'WritePay') {
            paysubmitInfo = {'click': 1}
            that.$emit('frameRiseBookingFun', paysubmitInfo)
          }
        }
        return res
      }).then(res => {
        this.$nextTick(() => {
          // 埋点日志记录
          var riseUpdate = {
            'product_price': product.totalprice,
            'product_currency': product.currency,
            'product_id': product.id,
            'product_subid': product.subid,
            'hotelid': this.hotelid,
            'checkin': this.startdate,
            'checkout': this.enddate,
            'adults': this.adult,
            'child': this.child,
            'room': this.room
          }
          this.clickPageAction('verify_rise_update', '', riseUpdate, data, res)
        })
      })
    }
  }
}
</script>

<style scoped>
.frame-small-img{width:80px; height:80px;cursor: pointer;}
.frame-text-rise{height:50px; line-height: 22px;font-size: 13px;color: #4F4C4C;text-align: left; margin-top: 10px;}
.dialog-goback{width: auto; border: 1px solid rgba(79, 76, 76, 1);border-radius: 4px;font-weight: 500;font-size: 14px;color: #4F4C4C;}
.dialog-goon{width: auto;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.dialog-goback:hover,.dialog-goon:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
.el-button+.el-button{margin-left:auto;}
/deep/ .el-dialog--center .el-dialog__body{padding: 10px 25px 30px !important;}
@media screen and (max-width: 1000px) {
.dialog-goback,.dialog-goon{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/frameRise.vue